import _ from "lodash";
import { Component, OnDestroy, ViewChild } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { MatPaginator as MatPaginator, PageEvent as PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TITLESPAGES } from "src/app/models/titlePage.model";
import { IUser } from "src/app/models/users.model";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { ViewComponent } from "src/app/shared/pages/view/view.component";
import { ProjectService } from "src/app/services/project.service";
import { groupBy } from "lodash";
import { CFJobType, ChildProject } from "src/app/models/projects/project.model";
import { IProjectFilters } from "../project-filters/project-filters.component";
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from "rxjs";
import { LivecoAPIService } from "src/app/services/liveco-api.service";


export enum colorsStatut {
    PRIMARY = "Primary"
}

export interface IMasterGroup {
    master: {
        id: string;
        identifier: string;
        marque: string;
        designation: string;
        cpp: IUser;
        isOld: boolean;
    };
    childs: ChildProject[];
}

@Component({
    selector: "app-project-dashboard",
    templateUrl: "./project-dashboard.component.html",
    styleUrls: ["./project-dashboard.component.scss"],
})
export class ProjectDashboardComponent extends ViewComponent implements OnDestroy {

    get page() {
        return this.s_projects.page;
    }

    filters: IProjectFilters = {
        __search: undefined,
        date_start: undefined,
        date_end: undefined,

        all_project: undefined,
        is_old: undefined,
        projects_archived: undefined,

        all_customer_project: undefined,
        customer: undefined,
        cpp: undefined,
        brand: undefined,
        printer: undefined,
        state_slugs: [],
        flows_slugs: undefined,

    };

    get query() {
        let { __search, cpp, customer, all_customer_project, brand, printer, all_project, is_old, projects_archived, date_start, date_end, state_slugs, flows_slugs } = this.filters;
        this.filters.all_customer_project = !!__search ? true : !!this.filters.all_customer_project;
        this.filters.all_project = !!__search ? true : !!this.filters.all_project;
        const q = _.omitBy({
            __search,
            type: CFJobType.JOB_ENFANT,
            "custom.general_info.cpp._id": cpp?._id || ((this.isCPP() && !this.filters.all_project) ? this.currentUser!._id : undefined),
            // "custom.general_info.cppID": cpp?._id || ((this.isCPP() && !all_project) ? this.currentUser!._id : undefined),
            "custom.general_info.customer.IDClient": customer?.IDClient || undefined,
            "custom.general_info.marque": brand?.label,
            "custom.printing.printer._id": printer?._id,
            ...(((this.isCPP() || this.isClient()) && projects_archived) || this.isOperator() ? {} : { 'state': { $ne: 'archived' } }),
            ...(((this.isOperator() && !this.isFab()) || is_old) ? { 'is_old': true } : {}),
            ...(date_start && date_end ? { birth: { $gte: date_start.toISOString(), $lte: date_end.toISOString() } } : {}),
            // CUSTOMER: 
            // "custom.members.usersID": this.isClient() && !this.filters.all_customer_project ? this.currentUser!._id : undefined,
            // QUERY ON PROOFREADING STATE
            state_slugs: state_slugs?.length ? state_slugs : undefined,
            // QUERY ON PROOFREADING FLOWS
            flows_slugs: flows_slugs?.length ? flows_slugs : undefined,
            // DISABLED BECAUSE OF PERMFORMANCES ISSUES
            ...((this.isClient() && !all_customer_project) ? {
                $and: [{
                    $or: [
                        { 'custom.members.usersID': this.currentUser!._id },
                        { 'looked_up.proofreadings.members.usersID': this.currentUser!._id }
                    ]
                }],
                $lookup: true,
            } : {}),

            // Params
            $no_parse: true,
            $sort: { birth: -1 },
        }, _.isNil);
        return q;
    }

    // Child project grouped by master project
    mapped_entities: IMasterGroup[] = [];

    get loading() {
        return this.s_projects.pending.entities;
    }


    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected dialog: MatDialog,
        protected s_auth: AuthService,
        protected titleService: Title,
        protected s_projects: ProjectService,
        protected translate: TranslateService,
        protected liveco: LivecoAPIService,
        
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        this.titleService.setTitle(TITLESPAGES.PROJECTS_TITLE);
        this.subscription.add(this.s_projects.entities$.subscribe(this.onDataRecieved.bind(this)));
        this.s_projects.resetEntities();

        // this.loaderService.loading = true;
        this.subscription.add(this.route.queryParams.subscribe(async (params) => {
            if (params && params['identifier']) {
                //Retrieve Project ID
                this.filters.__search = params['identifier'];
                await this.onFilter();
            }
        }));
        this.restoreFilters();
    }

    async retrieveData() {
        this.saveFiltersOnChange();
        this.page.$limit = parseInt(localStorage.getItem('liveco-default-page-size') || '10');
        this.page.$skip = (this.paginator?.pageIndex || 0) * this.page.$limit;

        await this.s_projects.find(this.query, {
            $page: this.page, $callbacks: {
                reload: () => this.query,
            }
        });
    }


    async onDataRecieved(): Promise<void> {
        const groupedEntities = groupBy(this.s_projects.entities, (entity) => entity?.id_maitre);
        this.mapped_entities = Object.entries(groupedEntities).map(([masterId, entities]) => {
            const master = {
                id: masterId,
                identifier: entities[0]?.id_maitre,
                marque: entities[0]?.custom?.general_info?.marque,
                designation: entities[0]?.custom?.general_info?.designation,
                cpp: entities[0]?.custom?.general_info?.cpp,
                isOld: entities[0]?.custom?.general?.is_old || false,
            };
            const childs = entities;
            return { master, childs };
        });
    }

    async onFilter() {
        if (this.paginator) this.paginator.pageIndex = 0;
        await this.retrieveData();
    }

    async onPage(event: PageEvent) {
        localStorage.setItem('liveco-default-page-size', event.pageSize.toString());
        await this.retrieveData();
    }

    protected saveFiltersOnChange() {
        const filters = JSON.stringify(this.filters);
        localStorage.setItem('liveco-filters-project-dashboard', filters);
    }

    protected restoreFilters() {
        const filters = localStorage.getItem('liveco-filters-project-dashboard');
        if (filters) {
            this.filters = JSON.parse(filters);
        }
    }

    async autoArchiving() {
        console.log('[archiving]');
        await this.liveco.find({}, "/project/auto-archive");

    }
}
